import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { claudeUsageAccessPermission } from '@internal/backstage-plugin-claude-usage-common';

import { claudeUsageApiRef } from './api/ClaudeUsageApi';
import { ClaudeUsageApiClient } from './api/ClaudeUsageApiClient';
import { rootRouteRef } from './routes';

const claudeUsageApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: claudeUsageApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ClaudeUsageApiClient({ discoveryApi, fetchApi }),
    }),
});

/**
 * The permission check lives here rather than in the app's route tree: the new
 * frontend system does not support wrapping routes in `RequirePermission`, so
 * plugins gate their own pages.
 */
const claudeUsagePage = PageBlueprint.make({
  params: {
    path: '/claude-usage',
    routeRef: rootRouteRef,
    // These pages render their own Header; suppress the default plugin page header.
    noHeader: true,
    loader: () =>
      import('./components/ClaudeUsagePage').then(m => (
        <RequirePermission permission={claudeUsageAccessPermission}>
          <m.ClaudeUsagePage />
        </RequirePermission>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'claude-usage',
  routes: {
    root: rootRouteRef,
  },
  extensions: [claudeUsageApi, claudeUsagePage],
});
